<template>
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.15706 7.71114L1.50006 13.3681L0.0860596 11.9541L5.03606 7.00414L0.0860596 2.05414L1.50006 0.640137L7.15706 6.29714C7.34453 6.48466 7.44985 6.73897 7.44985 7.00414C7.44985 7.2693 7.34453 7.52361 7.15706 7.71114Z"
      fill="currentColor"
    />
  </svg>
</template>